<template>
  <div v-show="loading" class="mask"></div>
</template>

<script>
export default {
  name: "view-loading",
  props: {
    loading: {
      default: true,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 2000px;
  height: 2000px;
  color: #fff;
  /* z-index: 999999; */
  background: #ccc;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/views/my-components/view-mask/view-mask.vue